module.exports = __webpack_public_path__ + "static/media/banner-big.eb3f938d.png";